import React from 'react';
import { Link } from 'react-router-dom';
import ResellerLoginForm from './components/ResellerLoginForm';
import SecurityFeatures from './components/SecurityFeatures';
import PartnerBenefits from './components/PartnerBenefits';
import Icon from '../../components/AppIcon';
import MainNavigation from '../../components/ui/MainNavigation';

const ResellerLogin = () => {
  return (
    <div className="min-h-screen bg-background flex flex-col">
      {/* Navigation */}
      <MainNavigation />

      {/* Main Content */}
      <main className="flex-1 py-8 sm:py-12 lg:py-16 pt-16 lg:pt-12 lg:ml-[72px] transition-all duration-300">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="grid grid-cols-1 lg:grid-cols-12 gap-6 sm:gap-8 items-start">
            {/* Left Column - Login Form */}
            <div className="lg:col-span-5 xl:col-span-4">
              <ResellerLoginForm />
            </div>

            {/* Right Column - Trust & Benefits */}
            <div className="lg:col-span-7 xl:col-span-8">
              <div className="space-y-6">
                {/* Welcome Section */}
                <div className="bg-gradient-to-r from-primary/10 to-secondary/10 rounded-lg border border-border p-6">
                  <div className="text-center mb-6">
                    <h2 className="text-2xl font-heading font-semibold text-foreground mb-3">
                      Reseller Partner Portal
                    </h2>
                    <p className="text-base font-body text-muted-foreground">
                      Enterprise toegang tot white-label marketplace management
                    </p>
                  </div>

                  <div className="grid grid-cols-1 sm:grid-cols-3 gap-3 sm:gap-4">
                    <div className="text-center">
                      <div className="w-12 h-12 bg-primary/10 rounded-full flex items-center justify-center mx-auto mb-2">
                        <Icon name="Building" size={24} color="var(--color-primary)" />
                      </div>
                      <div className="text-lg font-heading font-semibold text-primary">150+</div>
                      <div className="text-sm font-body text-muted-foreground">Partner Bedrijven</div>
                    </div>
                    <div className="text-center">
                      <div className="w-12 h-12 bg-secondary/10 rounded-full flex items-center justify-center mx-auto mb-2">
                        <Icon name="Users" size={24} color="var(--color-secondary)" />
                      </div>
                      <div className="text-lg font-heading font-semibold text-secondary">5.000+</div>
                      <div className="text-sm font-body text-muted-foreground">Beheerde Klanten</div>
                    </div>
                    <div className="text-center">
                      <div className="w-12 h-12 bg-success/10 rounded-full flex items-center justify-center mx-auto mb-2">
                        <Icon name="TrendingUp" size={24} color="var(--color-success)" />
                      </div>
                      <div className="text-lg font-heading font-semibold text-success">€5M+</div>
                      <div className="text-sm font-body text-muted-foreground">Maandelijkse Omzet</div>
                    </div>
                  </div>
                </div>

                {/* Two Column Layout for Desktop */}
                <div className="grid grid-cols-1 xl:grid-cols-2 gap-4 sm:gap-6">
                  {/* Security Features */}
                  <SecurityFeatures />
                  
                  {/* Partner Benefits */}
                  <PartnerBenefits />
                </div>
              </div>
            </div>
          </div>
        </div>
      </main>

      {/* Footer */}
      <footer className="bg-card border-t border-border">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-6 sm:py-8">
          <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-4 gap-4 sm:gap-6">
            {/* Company Info */}
            <div className="md:col-span-2">
              <div className="flex items-center space-x-2 mb-4">
                <div className="w-8 h-8 bg-primary rounded-md flex items-center justify-center">
                  <Icon name="Leaf" size={20} color="white" />
                </div>
                <span className="font-heading font-semibold text-xl text-foreground">
                  Verduurzaamwijzer
                </span>
              </div>
              <p className="text-sm font-body text-muted-foreground mb-4">
                Enterprise partner platform voor duurzaamheidsoplossingen.
              </p>
            </div>

            {/* Quick Links */}
            <div>
              <h4 className="text-sm font-heading font-medium text-foreground mb-3">
                Voor Resellers
              </h4>
              <ul className="space-y-2">
                <li>
                  <Link to="/reseller-registration" className="text-sm font-body text-muted-foreground hover:text-foreground transition-micro">
                    Partner Worden
                  </Link>
                </li>
                <li>
                  <Link to="/reseller-login" className="text-sm font-body text-muted-foreground hover:text-foreground transition-micro">
                    Inloggen
                  </Link>
                </li>
                <li>
                  <a href="#" className="text-sm font-body text-muted-foreground hover:text-foreground transition-micro">
                    API Documentatie
                  </a>
                </li>
              </ul>
            </div>

            {/* Support Links */}
            <div>
              <h4 className="text-sm font-heading font-medium text-foreground mb-3">
                Support
              </h4>
              <ul className="space-y-2">
                <li>
                  <a href="#" className="text-sm font-body text-muted-foreground hover:text-foreground transition-micro">
                    Technische Support
                  </a>
                </li>
                <li>
                  <a href="#" className="text-sm font-body text-muted-foreground hover:text-foreground transition-micro">
                    Partnership Overeenkomst
                  </a>
                </li>
              </ul>
            </div>
          </div>

          <div className="mt-6 sm:mt-8 pt-4 sm:pt-6 border-t border-border flex flex-col sm:flex-row justify-between items-center gap-4">
            <p className="text-xs font-caption text-muted-foreground">
              © {new Date()?.getFullYear()} Verduurzaamwijzer. Alle rechten voorbehouden.
            </p>
          </div>
        </div>
      </footer>
    </div>
  );
};

export default ResellerLogin;